  import React, { useState } from 'react';
  import { Form, Dropdown, Button, InputGroup } from 'react-bootstrap';
  
  function WatchlistFormStatic({
      watchlists = [{'watchlist_name':'Default'}], newWatchlistOption,
      watchListId, onWatchlistIdChange, addNewWatchlist, onAddNewWatchlist
      }) {
  // const [watchListId, setWatchListId] = useState("");
  // const [addNewWatchlist, setAddNewWatchlist] = useState(false);

  const handleChange = (e) => {
    onAddNewWatchlist(e.target.checked);  //  setAddNewWatchlist(e.target.checked);
  }

  return (
        <Form>
          <Form.Group>
            <Form.Label>Watch List</Form.Label>
            <Form.Control
              type="text"
              value={watchListId}
              onChange={(e) => onWatchlistIdChange(e.target.value)}
              placeholder={(watchlists && (watchlists.length > 0))? watchlists[0].watchlist_name : "Enter Watchlist Name"}
            />
          </Form.Group>
          {  newWatchlistOption ?
                (<Form.Group>
                  <Form.Check 
                    type="checkbox"
                    id="subscribe-checkbox"
                    label="Add new Watchlist"
                    checked={addNewWatchlist}    // Controlled component property
                    onChange={handleChange} // Event handler callback
                  />
                </Form.Group>)
              : (<></>)
          }

        </Form>
  )
}
export default WatchlistFormStatic;
